import React, { useEffect, useState } from "react";
import { Tabs, Tag } from "antd";
import { useSelector } from "react-redux";
import { Select } from "antd";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import { Table, Spin } from "antd";
import { getDataDoc } from "../../database";
import { Chart } from "react-google-charts";
import { calculare_medii } from "../../utils/calculare_medie";
import { DatePicker } from "antd";
import { db } from "../../database/firebase";
import { useReactToPrint } from "react-to-print";
import { Button } from "antd";
import { calculeaza_medie_materie } from "../../utils/calculare_medie";
import { motiveazaAbsente, motiveaza_absenta } from "../../utils/absente";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const StatisticiReligie = ({ clase, onDataLoaded }) => {
  const [eleviSelected, setEleviSelected] = useState([]);
  const navigate = useNavigate();
  
  // Funcție pentru sortarea după clasă și apoi alfabetic
  const sortEleviByClassAndName = (elevi) => {
    return elevi.sort((a, b) => {
      // Găsește clasa pentru fiecare elev
      const clasaA = clase?.find((c) => c.id === a.clasa);
      const clasaB = clase?.find((c) => c.id === b.clasa);
      
      if (!clasaA || !clasaB) {
        // Dacă nu găsim clasa, sortăm alfabetic după nume
        return a.nume.localeCompare(b.nume, 'ro');
      }
      
      // Funcție pentru a obține ordinea claselor
      const getClassOrder = (anClasa) => {
        const grade = anClasa?.toLowerCase();
        switch (grade) {
          case "pregătitoare": return 0;
          case "i": return 1;
          case "ii": return 2;
          case "iii": return 3;
          case "iv": return 4;
          case "v": return 5;
          case "vi": return 6;
          case "vii": return 7;
          case "viii": return 8;
          case "ix": return 9;
          case "x": return 10;
          case "xi": return 11;
          case "xii": return 12;
          case "xiii": return 13;
          case "anul i": return 14;
          case "anul ii": return 15;
          case "anul iii": return 16;
          case "anul iv": return 17;
          case "anul v": return 18;
          default: return 999;
        }
      };
      
      const orderA = getClassOrder(clasaA.anClasa);
      const orderB = getClassOrder(clasaB.anClasa);
      
      // Sortează mai întâi după ordinea clasei
      if (orderA !== orderB) {
        return orderA - orderB;
      }
      
      // Apoi după identificatorul clasei (A, B, C, etc.)
      if (clasaA.identificator !== clasaB.identificator) {
        return clasaA.identificator.localeCompare(clasaB.identificator);
      }
      
      // În final alfabetic după nume
      return a.nume.localeCompare(b.nume, 'ro');
    });
  };
  
  useEffect(() => {
    const fetchData = async () => {
      let array = [];
      let scutiriElevi = {};
      let note = {};
      let materii = [];
      const eleviRef = collection(db, "elevi");
      const q = query(eleviRef, where("religie", "!=", null)); // Verifică existența câmpului `religie`
      try {
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach(async (doc) => {
          const elev = doc.data();
          // Include și elevii cu religie penticostală și alți copii cu religie diferită
          if (
            elev.mutat !== true &&
            elev.retras !== true &&
            elev.religie !== "da" &&
            elev.religie?.length > 0
          )
            array.push({
              nume:
                elev.numeDeFamilie + " " + elev.initiala + " " + elev.prenume,
              id: doc.id,
              ...elev,
            });
        });
      } catch (error) {
        console.error("Eroare la preluarea datelor: ", error);
      }

      const sortedArray = sortEleviByClassAndName(array);
      setEleviSelected(sortedArray);
      if (onDataLoaded) {
        onDataLoaded(sortedArray);
      }
    };
    fetchData();
  }, [clase, onDataLoaded]);
  const columns = [
    {
      title: "Absente",
      dataIndex: "Phone",
      key: "phone",
      responsive: ["xs"],
      render: (e, data) => {
        const name = () => {
          return (
            <a
              onClick={() => {}}
              style={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {data.nume}
            </a>
          );
        };
        const clasa = () => {
          return (
            <a
              style={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {clase?.find((c) => c.id === data.class)?.anClasa +
                clase?.find((c) => c.id === data.class)?.identificator}
            </a>
          );
        };
        const religie = (e) => {
          return e.religie;
        };
        return (
          <div style={{ textAlign: "center" }}>
            <p>Nume: {name()}</p>
            <p>Clasa: {clasa()}</p>
            <p>Religie: {religie()}</p>
          </div>
        );
      },
    },
    {
      title: "Nume",
      dataIndex: "nume",
      key: "nume",
      responsive: ["sm"],
      onFilter: (value, record) => record.name.indexOf(value) === 0,
      render: (e, data) => {
        return (
          <a
            onClick={() => {
              navigate("/elev/" + data.id);
            }}
            style={{
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {data.nume}
          </a>
        );
      },
    },
    {
      title: "Clasa",
      dataIndex: "class",
      key: "class",
      responsive: ["sm"],

      onFilter: (value, record) => record.name.indexOf(value) === 0,
      render: (e, data) => {
        return (
          <a
            onClick={() => {}}
            style={{
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {clase?.find((c) => c.id === data.clasa)?.anClasa +
              clase?.find((c) => c.id === data.clasa)?.identificator}
          </a>
        );
      },
    },
    {
      title: "Religie",
      dataIndex: "religie",
      responsive: ["sm"],
      render: (e, data) => {
        return data.religie;
      },
    },
  ];

  return (
    <>
      <Table pagination={false} columns={columns} dataSource={eleviSelected} />
    </>
  );
};

const StatisticiCES = ({ clase, onDataLoaded }) => {
  const [eleviSelected, setEleviSelected] = useState([]);
  const navigate = useNavigate();

  // Funcție pentru sortarea după clasă și apoi alfabetic
  const sortEleviByClassAndName = (elevi) => {
    return elevi.sort((a, b) => {
      // Găsește clasa pentru fiecare elev
      const clasaA = clase?.find((c) => c.id === a.clasa);
      const clasaB = clase?.find((c) => c.id === b.clasa);

      if (!clasaA || !clasaB) {
        // Dacă nu găsim clasa, sortăm alfabetic după nume
        return a.nume.localeCompare(b.nume, 'ro');
      }

      // Funcție pentru a obține ordinea claselor
      const getClassOrder = (anClasa) => {
        const grade = anClasa?.toLowerCase();
        switch (grade) {
          case "pregătitoare": return 0;
          case "i": return 1;
          case "ii": return 2;
          case "iii": return 3;
          case "iv": return 4;
          case "v": return 5;
          case "vi": return 6;
          case "vii": return 7;
          case "viii": return 8;
          case "ix": return 9;
          case "x": return 10;
          case "xi": return 11;
          case "xii": return 12;
          case "xiii": return 13;
          case "anul i": return 14;
          case "anul ii": return 15;
          case "anul iii": return 16;
          case "anul iv": return 17;
          case "anul v": return 18;
          default: return 999;
        }
      };

      const orderA = getClassOrder(clasaA.anClasa);
      const orderB = getClassOrder(clasaB.anClasa);

      // Sortează mai întâi după ordinea clasei
      if (orderA !== orderB) {
        return orderA - orderB;
      }

      // Apoi după identificatorul clasei (A, B, C, etc.)
      if (clasaA.identificator !== clasaB.identificator) {
        return clasaA.identificator.localeCompare(clasaB.identificator);
      }

      // În final alfabetic după nume
      return a.nume.localeCompare(b.nume, 'ro');
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      let array = [];
      const eleviRef = collection(db, "elevi");
      const q = query(eleviRef, where("ces", "==", "da")); // Caută elevii cu CES
      try {
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach(async (doc) => {
          const elev = doc.data();
          // Include doar elevii cu CES care nu sunt mutați sau retrași
          if (elev.mutat !== true && elev.retras !== true)
            array.push({
              nume:
                elev.numeDeFamilie + " " + elev.initiala + " " + elev.prenume,
              id: doc.id,
              ...elev,
            });
        });
      } catch (error) {
        console.error("Eroare la preluarea datelor: ", error);
      }

      const sortedArray = sortEleviByClassAndName(array);
      setEleviSelected(sortedArray);
      if (onDataLoaded) {
        onDataLoaded(sortedArray);
      }
    };
    fetchData();
  }, [clase, onDataLoaded]);

  const columns = [
    {
      title: "CES",
      dataIndex: "Phone",
      key: "phone",
      responsive: ["xs"],
      render: (e, data) => {
        const name = () => {
          return (
            <a
              onClick={() => {
                navigate("/elev/" + data.id);
              }}
              style={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {data.nume}
            </a>
          );
        };
        const clasa = () => {
          return (
            <a
              style={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {clase?.find((c) => c.id === data.clasa)?.anClasa +
                clase?.find((c) => c.id === data.clasa)?.identificator}
            </a>
          );
        };
        return (
          <div style={{ textAlign: "center" }}>
            <p>Nume: {name()}</p>
            <p>Clasa: {clasa()}</p>
            <p>CES: DA</p>
          </div>
        );
      },
    },
    {
      title: "Nume",
      dataIndex: "nume",
      key: "nume",
      responsive: ["sm"],
      onFilter: (value, record) => record.name.indexOf(value) === 0,
      render: (e, data) => {
        return (
          <a
            onClick={() => {
              navigate("/elev/" + data.id);
            }}
            style={{
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {data.nume}
          </a>
        );
      },
    },
    {
      title: "Clasa",
      dataIndex: "class",
      key: "class",
      responsive: ["sm"],
      onFilter: (value, record) => record.name.indexOf(value) === 0,
      render: (e, data) => {
        return (
          <a
            onClick={() => {}}
            style={{
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {clase?.find((c) => c.id === data.clasa)?.anClasa +
              clase?.find((c) => c.id === data.clasa)?.identificator}
          </a>
        );
      },
    },
    {
      title: "CES",
      dataIndex: "ces",
      responsive: ["sm"],
      render: (e, data) => {
        return data.ces === "da" ? "DA" : "NU";
      },
    },
  ];

  return (
    <>
      <Table pagination={false} columns={columns} dataSource={eleviSelected} />
    </>
  );
};

async function getFilteredElevi() {
  const eleviRef = collection(db, "elevi");

  // Definim interogările individuale
  const queries = [query(eleviRef, where("transferuri", "!=", null))];

  // Executăm toate interogările simultan
  const snapshots = await Promise.all(queries.map((q) => getDocs(q)));

  // Stocăm rezultatele într-un Map pentru a evita duplicatele
  const uniqueElevi = new Map();

  snapshots.forEach((snapshot) => {
    snapshot.forEach((doc) => {
      uniqueElevi.set(doc.id, { idElev: doc.id, ...doc.data() });
    });
  });

  // Convertim Map-ul într-un array de obiecte și returnăm
  return Array.from(uniqueElevi.values());
}
const StatisticiTransferuri = ({ clase, onDataLoaded }) => {
  const [eleviSelected, setEleviSelected] = useState([]);
  const navigate = useNavigate();
  
  // Funcție pentru sortarea după clasă și apoi alfabetic
  const sortEleviByClassAndName = (elevi) => {
    return elevi.sort((a, b) => {
      // Găsește clasa pentru fiecare elev
      const clasaA = clase?.find((c) => c.id === a.clasa);
      const clasaB = clase?.find((c) => c.id === b.clasa);
      
      if (!clasaA || !clasaB) {
        // Dacă nu găsim clasa, sortăm alfabetic după nume
        return a.nume.localeCompare(b.nume, 'ro');
      }
      
      // Funcție pentru a obține ordinea claselor
      const getClassOrder = (anClasa) => {
        const grade = anClasa?.toLowerCase();
        switch (grade) {
          case "pregătitoare": return 0;
          case "i": return 1;
          case "ii": return 2;
          case "iii": return 3;
          case "iv": return 4;
          case "v": return 5;
          case "vi": return 6;
          case "vii": return 7;
          case "viii": return 8;
          case "ix": return 9;
          case "x": return 10;
          case "xi": return 11;
          case "xii": return 12;
          case "xiii": return 13;
          case "anul i": return 14;
          case "anul ii": return 15;
          case "anul iii": return 16;
          case "anul iv": return 17;
          case "anul v": return 18;
          default: return 999;
        }
      };
      
      const orderA = getClassOrder(clasaA.anClasa);
      const orderB = getClassOrder(clasaB.anClasa);
      
      // Sortează mai întâi după ordinea clasei
      if (orderA !== orderB) {
        return orderA - orderB;
      }
      
      // Apoi după identificatorul clasei (A, B, C, etc.)
      if (clasaA.identificator !== clasaB.identificator) {
        return clasaA.identificator.localeCompare(clasaB.identificator);
      }
      
      // În final alfabetic după nume
      return a.nume.localeCompare(b.nume, 'ro');
    });
  };
  
  useEffect(() => {
    const fetchData = async () => {
      let array = [];
      let scutiriElevi = {};
      let note = {};
      let materii = [];
      const eleviRef = collection(db, "elevi");
      const q = query(eleviRef, where("transferuri", "!=", null)); // Verifică existența câmpului `transferuri`
      try {
        const elevi = await getFilteredElevi();

        for (let elev of elevi)
          if (elev?.transferuri)
            array.push({
              nume:
                elev.numeDeFamilie + " " + elev.initiala + " " + elev.prenume,

              ...elev,
              id: elev.idElev,
            });
      } catch (error) {
        console.error("Eroare la preluarea datelor: ", error);
      }

      const sortedArray = sortEleviByClassAndName(array);
      setEleviSelected(sortedArray);
      if (onDataLoaded) {
        onDataLoaded(sortedArray);
      }
    };
    fetchData();
  }, [clase, onDataLoaded]);
  const columns = [
    {
      title: "Absente",
      dataIndex: "Phone",
      key: "phone",
      responsive: ["xs"],
      render: (e, data) => {
        const name = () => {
          return (
            <a
              onClick={() => {
                navigate("/elev/" + data.id);
              }}
              style={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {data.nume}
            </a>
          );
        };
        const clasa = () => {
          return (
            <a
              onClick={() => {}}
              style={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {clase?.find((c) => c.id === data.class)?.anClasa +
                clase?.find((c) => c.id === data.class)?.identificator}
            </a>
          );
        };
        const religie = (e) => {
          return e.religie;
        };
        return (
          <div style={{ textAlign: "center" }}>
            <p>Nume: {name()}</p>
            <p>Clasa: {clasa()}</p>
            {/* <p>Religie: {religie()}</p> */}
          </div>
        );
      },
    },
    {
      title: "Nume",
      dataIndex: "nume",
      key: "nume",
      responsive: ["sm"],
      onFilter: (value, record) => record.name.indexOf(value) === 0,
      render: (e, data) => {
        return (
          <a
            onClick={() => {
              navigate("/elev/" + data.id);
            }}
            style={{
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {data.nume}
          </a>
        );
      },
    },
    {
      title: "Clasa",
      dataIndex: "class",
      key: "class",
      responsive: ["sm"],

      onFilter: (value, record) => record.name.indexOf(value) === 0,
      render: (e, data) => {
        return (
          <a
            onClick={() => {}}
            style={{
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {clase?.find((c) => c.id === data.clasa)?.anClasa +
              clase?.find((c) => c.id === data.clasa)?.identificator}
          </a>
        );
      },
    },
    {
      title: "Religie",
      dataIndex: "religie",
      responsive: ["sm"],
      render: (e, data) => {
        return data.religie;
      },
    },
  ];

  return (
    <>
      <Table pagination={false} columns={columns} dataSource={eleviSelected} />
    </>
  );
};
function Statistici() {
  const [activeTab, setActiveTab] = useState("1");
  const [religieElevi, setReligieElevi] = useState([]);
  const [transferuriElevi, setTransferuriElevi] = useState([]);
  const [cesElevi, setCesElevi] = useState([]);
  const ref = useRef();
  const clase = useSelector((state) => state.clase);
  const settings = useSelector((state) => state.settings);

  const [loading, setLoading] = useState(false);

  //   useEffect(() => {
  //     setLoading(true);
  //     fetchData();
  //   }, [claseSelected]);

  const items = [
    {
      key: "1",
      label: `Religie`,
      children: <StatisticiReligie clase={clase || []} onDataLoaded={setReligieElevi} />,
    },
    {
      key: "2",
      label: `CES`,
      children: <StatisticiCES clase={clase || []} onDataLoaded={setCesElevi} />,
    },
    {
      key: "3",
      label: `Transferuri`,
      children: <StatisticiTransferuri clase={clase || []} onDataLoaded={setTransferuriElevi} />,
    },
  ];
  const handlePrint = useReactToPrint({
    content: () => ref.current,
  });

  const exportToExcel = () => {
    const wb = XLSX.utils.book_new();

    // Determină ce date să exportăm bazat pe tab-ul activ
    let dataToExport = [];
    let fileName = "";
    let sheetName = "";
    let columnHeader = "";

    if (activeTab === "1") {
      dataToExport = religieElevi;
      fileName = `Statistici-Religie-${new Date().toISOString().split("T")[0]}.xlsx`;
      sheetName = "Religie";
      columnHeader = "Religie";
    } else if (activeTab === "2") {
      dataToExport = cesElevi;
      fileName = `Statistici-CES-${new Date().toISOString().split("T")[0]}.xlsx`;
      sheetName = "CES";
      columnHeader = "CES";
    } else if (activeTab === "3") {
      dataToExport = transferuriElevi;
      fileName = `Statistici-Transferuri-${new Date().toISOString().split("T")[0]}.xlsx`;
      sheetName = "Transferuri";
      columnHeader = "Observații";
    }

    if (dataToExport.length === 0) {
      alert("Nu există date pentru export!");
      return;
    }

    // Pregătește datele pentru Excel
    const excelData = [
      ["Nume", "Clasa", columnHeader], // Header
      ...dataToExport.map((elev) => {
        const clasa = clase?.find((c) => c.id === elev.clasa);
        const numeClasa = clasa
          ? `${clasa.anClasa}${clasa.identificator}`
          : elev.clasa || "N/A";

        let thirdColumn = "N/A";
        if (activeTab === "1") {
          thirdColumn = elev.religie || "N/A";
        } else if (activeTab === "2") {
          thirdColumn = elev.ces === "da" ? "DA" : "NU";
        } else if (activeTab === "3") {
          thirdColumn = elev.observatii || "N/A";
        }

        return [
          elev.nume,
          numeClasa,
          thirdColumn
        ];
      }),
      [], // Linie goală
      ["INFORMAȚII RAPORT"],
      [`Total elevi: ${dataToExport.length}`],
      [`Generat la: ${new Date().toLocaleDateString('ro-RO', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })}`],
      [`Instituție: ${settings?.numeInstitutie || process.env.REACT_APP_NAME || "Școala"}`]
    ];

    const ws = XLSX.utils.aoa_to_sheet(excelData);
    XLSX.utils.book_append_sheet(wb, ws, sheetName);

    // Salvează fișierul
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], { type: "application/octet-stream" });
    saveAs(blob, fileName);
  };

  const Print = () => {
    const renderCurrentTab = () => {
      switch(activeTab) {
        case "1":
          return <StatisticiReligie clase={clase || []} onDataLoaded={() => {}} />;
        case "2":
          return <StatisticiCES clase={clase || []} onDataLoaded={() => {}} />;
        case "3":
          return <StatisticiTransferuri clase={clase || []} onDataLoaded={() => {}} />;
        default:
          return <StatisticiReligie clase={clase || []} onDataLoaded={() => {}} />;
      }
    };

    const getTabTitle = () => {
      switch(activeTab) {
        case "1":
          return "Statistici Religie";
        case "2":
          return "Statistici CES";
        case "3":
          return "Statistici Transferuri";
        default:
          return "Statistici Religie";
      }
    };

    return (
      <div ref={ref}>
        <div style={{
          textAlign: 'center',
          marginBottom: '30px',
          borderBottom: '2px solid #000',
          paddingBottom: '20px'
        }}>
          <h1 style={{ 
            fontSize: '24px', 
            fontWeight: 'bold', 
            margin: '0 0 10px 0',
            color: '#000'
          }}>
            {settings?.numeInstitutie || process.env.REACT_APP_NAME || "Instituția de Învățământ"}
          </h1>
          <h2 style={{ 
            fontSize: '18px', 
            fontWeight: '600', 
            margin: '0 0 5px 0',
            color: '#333'
          }}>
            Raport Statistici Școală
          </h2>
          <h3 style={{ 
            fontSize: '16px', 
            fontWeight: 'normal', 
            margin: '0 0 15px 0',
            color: '#666'
          }}>
            {getTabTitle()}
          </h3>
          <p style={{ 
            fontSize: '12px', 
            color: '#999',
            margin: '0'
          }}>
            Generat la data: {new Date().toLocaleDateString('ro-RO', {
              day: '2-digit',
              month: '2-digit', 
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            })}
          </p>
        </div>
        
        {renderCurrentTab()}
      </div>
    );
  };

  return (
    <div>
      <div style={{ display: "none" }}>
        <Print />
      </div>
      
      <br />
      <Spin tip="Loading" size="large" spinning={loading} />
      {loading === false && (
        <Tabs 
          defaultActiveKey="1" 
          items={items} 
          onChange={(key) => setActiveTab(key)}
        />
      )}
      <br />
      <div style={{ textAlign: 'center', gap: '10px', display: 'flex', justifyContent: 'center' }}>
        <Button type="primary" onClick={() => handlePrint()}>
          🖨️ Print
        </Button>
        <Button 
          type="default" 
          onClick={exportToExcel}
          style={{ backgroundColor: '#52c41a', borderColor: '#52c41a', color: 'white' }}
        >
          📊 Export Excel
        </Button>
      </div>
    </div>
  );
}

export default Statistici;
